import type { PlainDate } from "@sa-nu/shared-utils/date";

/**
 * レンジ幅が偶数で中央がちょうど取れない場合は切り捨て側（centerNight寄り）に丸める。
 */
export function computeCenteredRangeStart({
  centerNight,
  rangeSize,
}: {
  centerNight: PlainDate;
  rangeSize: number;
}): PlainDate {
  return centerNight.subtract({ days: Math.floor(rangeSize / 2) });
}
